import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-press-list',
  templateUrl: './press-list.component.html',
  styleUrls: ['./press-list.component.scss']
})
export class PressListComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
